export {
    airport,
    attraction,
    beach,
    bear,
    bicycle,
    binoculars,
    bird,
    bodyOfWater,
    bridge,
    building,
    bus,
    cafe,
    cairn,
    camera,
    campsite,
    canoe,
    car,
    cave,
    cemetery,
    chemist,
    circle,
    city,
    cliff,
    climbing,
    dam,
    danger,
    deer,
    disability,
    discGolf,
    dogPark,
    electric,
    elk,
    emergencyTelephone,
    fastFood,
    fence,
    fireLookout,
    fireStation,
    fish,
    forest,
    fuel,
    garden,
    gate,
    geyser,
    ghostTown,
    golf,
    grass,
    groundBlind,
    harbor,
    heart,
    helipad,
    heliport,
    horse,
    hospital,
    hotspring,
    information,
    knownRoute,
    lake,
    lighthouse,
    lodging,
    logging,
    market,
    marsh,
    mine,
    minefield,
    mobilephone,
    moose,
    mud,
    museum,
    mushroom,
    naturalSpring,
    noAdmittance1,
    noAdmittance2,
    number0,
    number1,
    number2,
    number3,
    number4,
    number5,
    number6,
    number7,
    number8,
    number9,
    offRoad,
    oilWell,
    park,
    parking,
    peak,
    petroglyph,
    picnic,
    pin,
    pitch,
    playground,
    police,
    pollingPlace,
    potableWater,
    prison,
    rail,
    railroad,
    rangerStation,
    reef,
    restaurant,
    resupply,
    ruins,
    rvPark,
    saddle,
    sandDune,
    scat,
    scrub,
    shelter,
    shower,
    skiing,
    snowflake,
    snowmobile,
    square,
    star,
    steps,
    stone,
    suitcase,
    swimming,
    toilets,
    trackDeer,
    trackDog,
    trailCamera,
    trailhead,
    trash,
    treeFall,
    treeStand,
    triangle,
    turkey,
    volcano,
    water,
    waterDrop,
    waterfall,
    wetland,
    wood,
} from './icons';
export {default as outlinedIconRaw} from './outlined-icon.svg?raw';
export {default as pinRaw} from './pin.svg?raw';
export {default as pinWhiteRaw} from './pin-white.svg?raw';
export {default as pinYellow} from './pin-yellow.svg';
export {pinBlack} from './pins';
export {pinBlue} from './pins';
export {pinBrown} from './pins';
export {pinGray} from './pins';
export {pinGreen} from './pins';
export {pinOrange} from './pins';
export {pinPurple} from './pins';
export {pinRed} from './pins';
export {pinWhite} from './pins';

export const outlinedIconWidth = 80;
export const outlinedIconHeight = 102;
export const pinWidth = 80;
export const pinHeight = 102;
